import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const RecsIcon = withSvgIcon(
    <path d="M500 500.6L394.4 375.1l80.4-94.3h-68.2l-67.5 78.8-38.2-44.8-94.8-112.1c26.5-4.5 49.4-16.1 68.6-34.7 19.2-18.6 28.9-39.5 28.9-62.7C303.6 34.7 243.8-.6 124.2-.6c-14.9 0-38.8.6-71.5 1.9S2.5 3.1 0 3.1v439.3h67.9V211.5c32.8 1.7 56.8 2.5 72 2.5l84.5 100.7 63 75-95 111h69.2l81.1-95.1 79.4 95.1H500zM115.5 171.1c-15.4 0-31.3-.8-47.6-2.5V48.5c20-1.6 33.3-2.5 40.1-2.5 43 0 74.5 4.5 94.4 13.6 19.9 9.1 29.9 24 29.9 44.6 0 25.1-9.3 42.5-27.9 52.2-18.5 9.9-48.1 14.7-88.9 14.7z" />
);
